export default class LocalDateTime {
  thisDate:Date = new Date();

  constructor();

  constructor(value:string);

  constructor(value:number[]);

  constructor(value:Date)

  constructor(value?:any) {
    if (value) {
      if (value instanceof Array) {
        this.initFromArray(value);
      } else if (typeof value === 'string') {
        const split:string[] = value.split(' ');
        const components:string[] = split[0].split('-');

        if (split.length > 1) {
          const timeComponents:string[] = split[1].split(':');
          for (let i:number = 0; i < timeComponents.length; i++) {
            components.push(timeComponents[i]);
          }
        }

        this.initFromArray(components);
      } else if (value instanceof Date) {
        this.thisDate = value;
      }
    }
  }

  initFromArray(value:any[]) {
    if (value.length >= 5) {
      this.thisDate = new Date(Date.UTC(value[0], value[1] - 1, value[2], value[3], value[4]));
      if (value.length > 5) {
        this.thisDate.setSeconds(value[5]);
      }

      if (value.length > 6) {
        this.thisDate.setMilliseconds(value[6]);
      }
    } else if (value.length === 3) {
      this.thisDate = new Date(value[0], value[1] - 1, value[2]);
    } else {
      throw new RangeError('Attempt to construct LocalDateTime without an expected number of fields. '
        + '(3 for date or 5+ for date and time.)');
    }
  }

  toFriendlyDateString() {
    return this.thisDate.toLocaleDateString();
  }

  toFriendlyDateTimeString() {
    return this.thisDate.toLocaleString();
  }

  toDate() {
    return this.thisDate;
  }

  toISODateString() {
    return this.thisDate.toISOString().substr(0, 10);
  }

  toDateArray() {
    return [this.thisDate.getUTCFullYear(), this.thisDate.getUTCMonth() + 1, this.thisDate.getUTCDate()];
  }

  toDateTimeArray() {
    return [
      this.thisDate.getUTCFullYear(),
      this.thisDate.getUTCMonth() + 1,
      this.thisDate.getUTCDate(),
      this.thisDate.getUTCHours(),
      this.thisDate.getMinutes(),
      this.thisDate.getSeconds(),
      this.thisDate.getMilliseconds(),
    ];
  }
}
